<template>
  <div
      :class="[
            'message-box',
            { 'eml-selected': selected },
            { 'is-open': isOpen },
        ]"
      v-bind="$attrs"
  >
    <div class="header">
      <div
          class="sub-header"
          @click="handleHeaderClick"
      >
        <div class="eml-info-left">
          <div class="eml-user-icon image is-32x32">
            <img
                :src="image_url"
                class="note-avatar"
             alt=""/>
          </div>
          <div class="eml-info">
            <strong class="from">{{ message.from }}</strong>
            <span class="recipients">{{ recipients }}</span>
          </div>
          <div>
            <o-dropdown
                class="eml-info-dd"
                aria-role="menu"
            >
              <template #trigger>
                <o-button
                    class="eml-info-btn"
                    icon-right="info"
                    ref="info_button"
                    size="is-small"
                />
              </template>
              <o-dropdown-item
                  aria-role="menu-item"
                  custom
                  paddingless
              >
                <div class="eml-table-ctn">
                  <table
                      class="table"
                      style="width: 100%; margin-bottom: 0px"
                  >
                    <tbody>
                    <tr>
                      <td>from:</td>
                      <td>{{ message.from }}</td>
                    </tr>
                    <tr class="wsnormal">
                      <td>to:</td>
                      <td>{{ message.to }}</td>
                    </tr>
                    <tr
                        class="wsnormal"
                        v-if="message.cc"
                    >
                      <td>cc:</td>
                      <td>{{ message.cc }}</td>
                    </tr>
                    <tr>
                      <td>date:</td>
                      <td>
                        {{ message_date }}
                      </td>
                    </tr>
                    <tr class="wsnormal">
                      <td>subject:</td>
                      <td>{{ message.subject }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </o-dropdown-item>
            </o-dropdown>
          </div>
        </div>
        <span class="date is-pulled-right">
                    <span>{{ message_date }}</span>
                    <small>({{ $filters.ago(message.date) }})</small>
                </span>
      </div>
      <span class="header-buttons is-pulled-right">
                <o-tooltip label="Reply">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('reply', message)"
                    >
                        <o-icon
                            pack="fa"
                            icon="reply"
                            size="is-small"
                        />
                    </a>
                </o-tooltip>
                <o-tooltip
                    label="Reply all"
                    v-if="isReplyAllActive"
                >
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('replyall', message)"
                    >
                        <o-icon
                            pack="fa"
                            icon="reply-all"
                            size="is-small"
                        />
                    </a>
                </o-tooltip>
                <o-tooltip label="Forward">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('forward', message)"
                    >
                        <o-icon
                            pack="fa"
                            icon="share"
                            size="is-small"
                        />
                    </a>
                </o-tooltip>
                <o-tooltip label="Mark unread">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('markunread', message)"
                    >
                        <o-icon
                            pack="fa"
                            icon="envelope"
                            size="is-small"
                        />
                    </a>
                </o-tooltip>
                <o-tooltip label="Delete">
                    <a
                        class="header-button navbar-item between-center"
                        @click.prevent="$emit('delete', message)"
                    >
                        <o-icon
                            pack="fa"
                            icon="trash"
                            size="is-small"
                        />
                    </a>
                </o-tooltip>
                <o-dropdown position="bottom-left">
                    <a
                        class="header-button navbar-item between-center"
                        slot="trigger"
                    >
                        <o-icon
                            pack="fa"
                            icon="ellipsis-v"
                        > </o-icon>
                    </a>
                    <o-dropdown-item has-link>
                        <a
                            href="#"
                            @click.prevent="handle_add_to_work"
                        >{{
                            add_to_work_text
                          }}</a>
                    </o-dropdown-item>
                    <o-dropdown-item has-link>
                        <a
                            href="#"
                            @click.prevent="$emit('set-reminder', message)"
                        >Set Reminder</a>
                    </o-dropdown-item>
                </o-dropdown>
            </span>
    </div>
    <div
        class="eml-msg-ctn"
        v-if="isOpen"
    >
      <div
          class="break-word"
          ref="message_body"
      />
      <ul v-if="message.files && message.files.length">
        <template v-for="(file, key) in message.files" :key="key">
          <li>
                        <span class="icon is-small">
                            <i class="fa fa-file" />
                        </span>
            <a
                :href="file.path || file.data_url"
                target="_blank"
                @click.prevent="handle_open_file(file)"
            >{{ file.name }}</a>
            <span>{{ $filters.readableSize(file.size) }}</span>
          </li>
        </template>
      </ul>
    </div>
    <o-modal
        :active.sync="isPreviewModalActive"
        class="preview-modal"
        has-modal-card
    >
      <file-preview-modal :file="currentPreviewFile" />
    </o-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import ReplyBox from "./ReplyBox.vue"
import {fetch_file, get_message_files, get_recipients_names, mark_message_as_read} from '../../modules/emails/gmail_api'
import FilePreviewModal from './../../modules/emails/components/modals/FilePreviewModal'

const image = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAIAAAADnC86AAAAA3NCSVQICAjb4U/gAAAAl3pUWHRSYXcgcHJvZmlsZSB0eXBlIEFQUDEAABiVVY5RCsQwCET/c4oeYdTEJMcJJV0Ky7b0/h+bNHa7fYIjI4y6V/3UY52n/diW9V3d1CFKzmefuQBIGDAgBOqKaJYO1ZwifBvI/IoHPurSKuqs4TSktzxyPMwSbtUyythb1k9Dwf+NcP11wbbjOzOwZEnmPW+RjCdO3BdH2DYTyjfH2QAAApNJREFUWIXVWMuyojAQTSegPAopCl35/7/mCoSSSwgB0rNIDRcRsXG8dWvO0jR90u+OgIjsN8B/hfX/JDbGGGPe/tzZFGMA6PteSqm1th8CgOu6YRg6zkZV9FsDgJSyrmsAmB0hYhiGQRDQuanEAFDX9SLrlDsMQyI3NcZa6xVWe7Ovry+tNVEhiRgAbrcbYwxXYcVWLreZuG3bYRgoksMwtG1LkXydigDQNA0xcojYNM1ut3sp71DU2cgRuYkWv3Y1IhL9bGGMoVyRRLx1kFBK9Ed6NSWxSckFAFs762eSSwjR9z2RVQhBESO5er/f08vJ87zPECOi7f5EEEcFyWIhhO/7tk5WYIzxfZ/oatIQRcQ4jpVS63UCAHEcE8fdhnI6Ho/sSf+yP55OJ7o26LqOKgpgjMnzXCk1rVSbUGmacs43LAJEYrv0cM6FEFprKaUtMMdxgiDY7XbGmL7vXdclcsPL0W0NLcuyrmshRJIkQRDMZJRSRVF0XRcEQZIkFNNfEANA27ZZltk5zxhDRM6553mu6zLG+r5XSg3DMJ4yxtI09X1/nXuN2G53eZ4v9l78u2U+HhljkiQ5HA4rGf60nOx2l+c558uZvzIJOOdFUTDGoih6xr3cq0cPb0rUmYbr9eo4jud5ixpgcWFAxMvl8h7lDOfzedE3C24EgCzL/uV5MgIRsyxbJJ7H2CaUlPJtJ88gpWya5tHhCxYXRUHcjSkAgLIsHxXOk0sppbX+lLmjzrZtbd2P4NO5xhirquqD5loAQFVV7P4hcmcxIkopGXmFpqOu6zRNp2q/YwwAWuuPJPMjhmGYtcg7i5VS7AfMtTqVUlEUjcr5NMDE18cbsK2QTcL87WpEpC8Fb2D898LiD+rnWjcJPzKGAAAAAElFTkSuQmCC'
export default {
  components: { FilePreviewModal, ReplyBox },
  computed: {
    ...mapGetters(["emails_get_profile"]),
    add_to_work_text() {
      const { references } = this.message
      return (
          (!!references && references.length && "Edit work") ||
          "Add to"
      )
    },
    image_url() {
      const email =
          (!!this.emails_get_profile && this.emails_get_profile.email) ||
          null
      return (
          ([email, "me"].includes(this.message.from) &&
              `/avatar/${Laravel.currentUser.full_name}.png`) ||
          image
      )
    },
    isReplyAllActive() {
      const { cc = '', to = '' } = this.message
      return (cc || '').split(' ').length > 1 || (to || '').split(' ').length > 1
    },
    message_body() {
      const { body, files = [] } = this.message, el = this.el = document.createElement('div')
      el.innerHTML = body
      let blockquote = el.querySelector('div.gmail_quote>blockquote.gmail_quote')
      if (blockquote) {
        const parent = blockquote.parentElement
            , button = document.createElement('span')
        parent.classList.add('show-msg-btn')
        button.classList.add('before')
        button.setAttribute('onclick', "Array.from(this.parentNode.classList).includes('active') ? this.parentNode.classList.remove('active') : this.parentNode.classList.add('active')")
        parent.appendChild(button)
      }
      this.files_loaded && files.forEach(file => {
        if (file.disposition === 'inline') {
          const cid = `cid:${file.content_id}`
          el.querySelectorAll(`[src="${cid}"]`).forEach(item => item.src = file.path)
        }
      })
      return el.innerHTML
    },
    message_date() {
      return moment(this.message.date).format("ddd, MMM DD, YYYY, h:mm A")
    },
    recipients() {
      const recipients = get_recipients_names(this.message)
      return recipients && `to ${recipients}` || ''
    },
  },
  data() {
    return {
      currentPreviewFile: null,
      files_loaded: false,
      isOpen: false,
      isPreviewModalActive: false,
    }
  },
  methods: {
    get_files() {
      if (this.isOpen) {
        const { message } = this
        if (!message.files) {
          message.files = get_message_files(message)
        }
      }
    },
    get_image(){
      const { file } = this
      return file
    },
    handleHeaderClick(event) {
      if (!this.$refs.info_button.$el.contains(event.target)) {
        this.isOpen = !this.isOpen
        this.$emit("onselect", this.message)
      }
    },
    handle_add_to_work() {
      this.$emit('onselect', this.message)
      this.$emit('add-to-work')
    },
    handle_open_file(file) {
      this.currentPreviewFile = file
      this.isPreviewModalActive = true
    },
    init() {
      if (!this.isOpen) {
        return
      }
      this.$nextTick(() => {
        const el = this.$refs.message_body
        if (!el || el.innerHTML) {
          return
        }
        el.innerHTML = ''
        const shadow = el.attachShadow({ mode: 'open' })
            , container = document.createElement('div')
            , style = document.createElement('style')
        style.innerHTML = `.show-msg-btn{background:none;position:relative}.show-msg-btn .before{background-color:#e8eaed;background-image:url("https://www.gstatic.com/images/icons/material/system_gm/1x/more_horiz_black_20dp.png");background-position:center;background-repeat:no-repeat;background-size:20px;border:none;border-radius:5.5px;content:" ";cursor:pointer;height:11px;opacity:.71;position:absolute;top:-11px;width:24px}.show-msg-btn:hover .before,.show-msg-btn .before:hover{background-color:#dadce0}.show-msg-btn:not(.active)>div,.show-msg-btn:not(.active)>blockquote{display:none}`
        container.innerHTML = this.message_body
        setInterval(() => {
          container.querySelectorAll("img[src]").forEach(value => {
            this.get_image()
                .filter(val => value.getAttribute("src").includes(val.content_id))
                .map(image => {
                  image.disposition === "inline" ? value.setAttribute("src", image.data_url) : ""
                })
          })
        }, 1000)
        container.appendChild(style)
        shadow.appendChild(container)
      })
      const message = this.message
      Array.isArray(message.label_ids) && message.label_ids.includes("UNREAD") && mark_message_as_read(message.message_id)
    },
  },
  mounted() {
    this.isOpen = !!this.open
    this.get_files()

  },
  props: ['addToWorkText', 'message', 'open', 'selected', 'file'],
  watch: {
    isOpen() {
      this.get_files()
      this.init()
    },
  },
}
</script>

<style>
.eml-msg-ctn{
  width: 70%;
}
.sub-header{
  background-color: #ffffff;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.1);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
  padding: 20px;
  margin: 15px;
}
</style>